import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './GroupTitle.scss';

interface IOwnProps {
  title: string;
  readOnly?: boolean;
  accent?: boolean;
  variant?: 'big';
}
const GroupTitle: React.SFC<IOwnProps> = ({ title, readOnly, accent, variant }) => {
  if (readOnly) { return null; }

  const classNames = cx({
    [Styles.title]: true,
    [Styles.accent]: accent,
    [Styles.big]: variant === 'big',
  });

  return (
    <div className={classNames}>{title}</div>
  );
};

export default GroupTitle;
